<template>
  <div v-if="show"
    class="fixed top-0 left-0 w-full h-full flex bg-black bg-opacity-25 items-center justify-center z-[99] modal-container">
    <div class="mx-4 w-full max-w-[720px] h-auto p-4 bg-white rounded-lg max-h-90 modal relative">
      <div
        class="absolute top-2 right-2 md:top-3 md:right-3 bg-ROJO_LEON rounded-full py-3 px-2 cursor-pointer inline cerrar transition"
        @click="closeModal">
        <div class="bg-white h-1 w-4 rounded-full rotate-45 relative top-[2px]"></div>
        <div class="bg-white h-1 w-4 rounded-full -rotate-45 relative -top-[2px]"></div>
      </div>
      <div class="flex justify-center items-center">
        <img :src="'/img/home/battery/leon-lupa.png'" alt="lupa" />
      </div>

      <h3 class="font-extrabold text-center text-xl mt-3">
        NO ENCONTRAMOS TU PATENTE
      </h3>
      <div class="flex justify-center items-center mt-3">
        <div
          class="border-4 border-black rounded-xl flex-col justify-center items-center text-3xl font-black font-nunito tracking-widest pt-6 px-6">
          <template v-for="(char, index) in formattedPlate" :key="index">
            <span class="mx-2">{{ char }}</span>
            <span v-if="index === 1" class="dot-separator text-4xl mx-5">•</span>
            <img v-if="index === 3" :src="'/img/home/battery/escudo_cl.png'" class="mx-5 h-5 inline" alt="" />
          </template>
          <div class="text-center text-lg mt-2">CHILE</div>
        </div>
      </div>

      <h3 class="text-center mt-8 font-semibold text-lg text-GRIS_LEON">
        Verifica que esté bien escrita o comunícate con uno de nuestros
        ejecutivos
      </h3>

      <div class="flex flex-row justify-center py-4 md:py-8">
        <button
          class="border bg-VERDE_TOP_CALIDAD rounded-xl py-2 px-4 text-sm md:text-xl font-bold text-white flex items-center justify-center"
          @click="clearPlate">
          Buscar por patente
        </button>

        <button
          class="border bg-white border-VERDE_TOP_CALIDAD rounded-xl ml-3 py-2 px-4 text-xl font-bold text-VERDE_TOP_CALIDAD flex items-center justify-center"
          @click="callContact">
          <img :src="'/img/home/battery/call.png'" alt="phone" class="mr-2" />
          Contáctanos
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
  show: {
    type: Boolean,
    required: true,
  },
  selectPlate: {
    type: String,
    required: true,
  },
});

const emit = defineEmits(['closeModal', 'clearPlate', 'callContact']);

const formattedPlate = computed(() => props.selectPlate.split(""));

function closeModal() {
  emit("closeModal");
}

function clearPlate() {
  emit("clearPlate");
}

function callContact() {
  emit("callContact");
}
</script>

<style scoped>
.dot-separator {
  font-size: 2.5rem;
  font-weight: bold;
}
</style>